/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactNode } from 'react';
import styles from './OfferBadge.module.scss';
import clsx from 'clsx';
import { Badge, Link } from '@gjensidige/builders-components';
import tokens from '@gjensidige/builders-tokens';
import { AppConstants } from '../../utils/AppConstants';
import { InformationModal } from '../Common/InformationModal/InformationModal';

export interface IOfferBadgeProps {
    className?: string;
    modalHeading: string;
    modalMessage: string;
    linkText: string;
}

export function OfferBadge (props: IOfferBadgeProps) {
  return (
    <div className={clsx(styles.badgeParent, props.className)}>
    <div className={styles.badgeWrapper}>
      <div className={styles.badgeInnerWrapper}>
        <Badge className={styles.badge} severity="suggestive">
          {/* <Link href="#" variant="action" tabindex="0">{props.children}</Link> */}
          <InformationModal
            linkText={props.linkText}
            modalContent={[
              {
                title: props.modalHeading,
                details: props.modalMessage
              }
            ]}
            buttonSize="sm"
            buttonClassName="recommended-link"
            displayAsWhiteLink
            modalAriaLabel='Hjälp om vårt förslag'
          />
        </Badge>
      </div>
      <div className={styles.badgeArrowWrapper}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="14"
          fill="none"
          className={styles.badgeArrow}
        >
          <path
            stroke="none"
            d="M10 1c3.18 3.99 6.83 8.51 10 12.5H0C3.16 9.51 6.84 4.99 10 1Z"
          />
          <path
            stroke={tokens.color.purple700}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.53 12.5 10.01 1A4971.7 4971.7 0 0 0 .5 12.5"
          />
        </svg>
      </div>
    </div>
  </div>
  );
}
